export class PersonaCategoriaTipoCategoriaAreaLogicaModel {
  id: number = 0;
  codigo: string = '';
  acronimo: string = '';
  nombre: string = '';
  descripcion: string = '';
  visibleMenu: number = 0;
  name: string = '';

  constructor() { }
}
